import { elsterDocxUtils, emptyLine } from '../utils/elster_docx_utils';
import i18n from 'i18next';
import { FINAL_DECLARATION_ONE } from '../constants/elsterDocxConstants';
import generalTable from '../utils/generalTable';
import { bookmarkParagraphOptions, bookmarkStyle } from '../styles/elsterDocStyles';
import { section6TextsEn } from './section6_texts/section6Texts';
import { useSelector } from 'react-redux';
const section6 = (data, user, elsterVersion) => {
  const {
    t
  } = i18n;
  const userLanguage = (user === null || user === void 0 ? void 0 : user.local_language) === 'de' ? 'de' : 'en';
  const {
    createBookmark,
    createParagraphWithLineBreaks
  } = elsterDocxUtils;
  const hardCodedData = {
    finalDeclarationOneHardcodedValue: true,
    finalDeclarationTwoHardcodedValue: true
  };
  const bookMarkTitle = elsterVersion === 'version_8' ? 'tk_final_dec_8' : 'tk_final_dec_6';
  return [createBookmark(t(bookMarkTitle), "anchor_".concat(bookMarkTitle), bookmarkStyle, bookmarkParagraphOptions), createParagraphWithLineBreaks(section6TextsEn[userLanguage], {
    style: 'small_text'
  }),
  // keep it commented out for now, or replace with line above createParagraphWithLineBreaks
  // createTextRunInParagraph(t('tk_final_dec_6_long_text'), grayTitlesMain, mainParagraphOptions),

  emptyLine, generalTable(hardCodedData, FINAL_DECLARATION_ONE), emptyLine];
};
export default section6;